<template>
  <div class="export-pdf-container basic-fact-container">
    <!--    <div class="box-header">-->
    <!--      <p class="title">BASIC FACTS AND FIGURES</p>-->
    <!--    </div>-->
    <!--    <div class="content content-facts">-->
    <!--      <table class="total-table">-->
    <!--        <tr class="none-column">-->
    <!--          <td colspan="2"></td>-->
    <!--        </tr>-->
    <!--        <tr class="total-header">-->
    <!--          <td>Total training size:</td>-->
    <!--          <td>{{ totalTrainingSize | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Undergraduate students:</td>-->
    <!--          <td>{{ programData.undergraduate | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Master students:</td>-->
    <!--          <td>{{ programData.master | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Doctoral students:</td>-->
    <!--          <td>{{ programData.doctoral | formatNumber }}</td>-->
    <!--        </tr>-->

    <!--        <tr class="total-header">-->
    <!--          <td>Total number of academics:</td>-->
    <!--          <td>{{ numberOfAcademics | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Full-time faculty staff:</td>-->
    <!--          <td>{{ programData.staff_full_time | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Part-time lecturers/professors:</td>-->
    <!--          <td>{{ programData.staff_part_time | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Full-time faculty staff with doctorate degree:</td>-->
    <!--          <td>{{ programData.doctoral_full_time | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>-->
    <!--            Full-time faculty staff bearing titles of Professor or Assoc.-->
    <!--            Professor:-->
    <!--          </td>-->
    <!--          <td>{{ programData.pap_full_time | formatNumber }}</td>-->
    <!--        </tr>-->

    <!--        <tr class="total-header">-->
    <!--          <td>Total number of education programs:</td>-->
    <!--          <td>{{ totalEducationPrograms | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Undergraduate programs:</td>-->
    <!--          <td>{{ programData.undergraduate_program | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Master programs:</td>-->
    <!--          <td>{{ programData.master_program | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--        <tr class="total-content">-->
    <!--          <td>Doctoral programs:</td>-->
    <!--          <td>{{ programData.doctoral_program | formatNumber }}</td>-->
    <!--        </tr>-->
    <!--      </table>-->
    <!--    </div>-->

    <div class="box-header">
      <p class="title">GENERAL ANALYSIS</p>
      <div class="content">
        <div class="box-chart">
          <!--Biểu đồ minh họa-->
          <!--        <img :src="'img/imgPdf/chart.png'" alt="" />-->
          <radar-chart
            v-if="chartData.labels.length > 0"
            :chartData="chartData"
            :options="chartOptions"
          ></radar-chart>
        </div>
      </div>
    </div>
    <div class="box-footer box-header">
      <p class="title">Innovate to Transcend</p>
    </div>
  </div>
</template>

<script>
import RadarChart from "../../../components/Charts/RadarChart.js";

export default {
  name: "BasicFacts",
  components: { RadarChart },
  data() {
    return {
      programData: {
        master: 0,
        master_program: 0,
        pap_full_time: 0,
        staff_full_time: 0,
        staff_part_time: 0,
        undergraduate: 0,
        undergraduate_program: 0,
        doctoral_program: 0,
        doctoral_full_time: 0,
        doctoral: 0
      },
      chartOptions: {
        hoverBorderWidth: 20,
        legend: {
          display: false
        },
        elements: {
          line: {
            borderWidth: 4
          }
        },
        scale: {
          ticks: {
            // changes here
            beginAtZero: true,
            max: 1,
            min: 0,
            stepSize: 0.1
          },
          pointLabels: {
            fontSize: 14,
            fontColor: "black",
            fontStyle: 600
          },
          gridLines: {
            color: "#548235"
          },
          angleLines: {
            color: "#ed7d31"
          }
        }
      },
      chartData: {
        labels: [],
        datasets: [
          {
            label: "My First Dataset",
            data: [],
            fill: true,
            backgroundColor: "transparent",
            borderColor: "#FFA163FF",
            pointBackgroundColor: "#e02828",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#FFA163FF",
            hoverBorderWidth: 20
          }
        ]
      }
    };
  },
  props: {
    programInfo: {
      type: Object
    },
    programCategoryRating: {
      type: Array
    }
  },
  watch: {
    programInfo: {
      handler(newVal) {
        this.initProgramData(newVal);
      },
      deep: true
    },
    programCategoryRating: {
      handler(newVal) {
        this.initChartData(JSON.parse(JSON.stringify(newVal)));
      },
      deep: true
    }
  },
  computed: {
    totalTrainingSize() {
      return (
        this.programData.master +
        this.programData.doctoral +
        this.programData.undergraduate
      );
    },
    totalEducationPrograms() {
      return (
        this.programData.doctoral_program +
        this.programData.master_program +
        this.programData.undergraduate_program
      );
    },
    numberOfAcademics() {
      return (
        this.programData.pap_full_time +
        this.programData.staff_full_time +
        this.programData.staff_part_time +
        this.programData.doctoral_full_time
      );
    }
  },
  mounted() {
    this.initProgramData(this.programInfo);
  },
  methods: {
    initProgramData(newVal) {
      this.programData.master = newVal.master || 0;
      this.programData.undergraduate = newVal.undergraduate || 0;
      this.programData.doctoral = newVal.doctoral || 0;
      this.programData.pap_full_time = newVal.pap_full_time || 0;
      this.programData.staff_full_time = newVal.staff_full_time || 0;
      this.programData.staff_part_time = newVal.staff_part_time || 0;
      this.programData.doctoral_full_time = newVal.doctoral_full_time || 0;
      this.programData.undergraduate_program =
        newVal.undergraduate_program || 0;
      this.programData.master_program = newVal.master_program || 0;
      this.programData.doctoral_program = newVal.doctoral_program || 0;
    },
    async initChartData(newVal) {
      if (!newVal) return;
      let chartLabels = [];
      let chartDataSets = [];
      const newCharData = JSON.parse(JSON.stringify(newVal));
      newCharData.forEach(cate => {
        chartLabels.push(
          cate.criterion_category ? cate.criterion_category.name : "N/A"
        );
        chartDataSets.push(this.getPercentRound(cate.score, cate.weight));
      });
      this.chartData.datasets[0].data = JSON.parse(
        JSON.stringify(chartDataSets)
      );
      this.chartData.labels = JSON.parse(JSON.stringify(chartLabels));
    },
    getPercentRound(up, down) {
      return up && down ? Number.parseFloat((up / down).toFixed(1)) : 0;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/program-pdf.scss";
</style>
